/**
 * The names the store's pages show for category and genre ids — the client's
 * copies of the platform's lists (`client/src/lib/app-categories.ts`,
 * `client/src/lib/game-genres.ts`, each pinned to the server's).
 */
import { APP_CATEGORY_OPTIONS } from '@/lib/app-categories';
import { GAME_GENRE_OPTIONS } from '@/lib/game-genres';

export const STORE_CATEGORY_LABELS: Readonly<Record<string, string>> = Object.fromEntries(
  APP_CATEGORY_OPTIONS.map((c) => [c.id, c.label]),
);

export const STORE_GENRE_LABELS: Readonly<Record<string, string>> = Object.fromEntries(
  GAME_GENRE_OPTIONS.map((g) => [g.id, g.label]),
);
